import classNames from 'classnames';
import { SchemaBrowserType, SchemaEditorViewModeType } from 'js/constants/schemaEditor';
import { ReactComponent as EditIcon } from 'new/components/icons/pen.svg';
import React from 'react';
import AutoSizingSearchInput from '../elements/AutoSizingSearchInput';
import Tooltip from '../elements/mui/Tooltip';
import RecipeBuilderGrid from './RecipeBuilderGrid';
import RecipeBuilderOutputError from './RecipeBuilderOutputError';
import SelectAllAttrsCheckbox from './SelectAllAttrsCheckbox';

class RecipeBuilderSamples extends React.PureComponent {
  state = {
    searchText: '',
  };

  render() {
    const {
      gridId,
      schema,
      headingIcon,
      headingText,
      selectedViewMode,
      allowEditing,
      allowSelection,
      onEditClicked,
      showMeta,
      onShowMetaChanged,
      dataSet,
    } = this.props;
    const { searchText } = this.state;

    return (
      <>
        <div
          className={classNames('recipe-samples-header', {
            'is-selection-enabled': allowSelection,
          })}
        >
          <div className="recipe-samples-header-left-content">
            {allowSelection && <SelectAllAttrsCheckbox gridId={gridId} schema={schema} />}
            {headingIcon}
            <span className="recipe-samples-header-text">{headingText}</span>
            {allowEditing && selectedViewMode !== SchemaEditorViewModeType.CODE && (
              <Tooltip title="Edit Cached Samples" arrow>
                <button onClick={onEditClicked} className="recipe-builder-header-button">
                  <EditIcon fontSize="small" />
                </button>
              </Tooltip>
            )}
          </div>
          {selectedViewMode !== SchemaEditorViewModeType.CODE && (
            <AutoSizingSearchInput
              searchText={searchText}
              onChange={this._handleSearchTextChanged}
            />
          )}
        </div>
        {gridId === SchemaBrowserType.OUTPUT && (
          <RecipeBuilderOutputError flowType={dataSet?.flow_type} />
        )}
        <RecipeBuilderGrid searchText={searchText} {...this.props} />
      </>
    );
  }

  _handleSearchTextChanged = (searchText) => {
    this.setState({ searchText });
  };

  _handleToggleMeta = (currentShowMeta) => {
    const { onShowMetaChanged } = this.props;
    if (onShowMetaChanged) {
      onShowMetaChanged(!currentShowMeta);
    }
  };
}

export default RecipeBuilderSamples;
